export const GET_SNIPPETS_SUCCESS = 'GET_SNIPPETS_SUCCESS';
export const SET_SNIPPETS_LOADING = 'SET_SNIPPETS_LOADING';
